/* eslint semi:0 */
import React from 'react'

function SelectOption(optionText, blockName) {
  const optionProps = {
    key: optionText,
    value: optionText,
    children: optionText,
    className: `${blockName}__option`,
  }
  return <option {...optionProps} />
}

export default function TvChannelSelection({
  blockName,
  modifier,
  entityName,
  available = [],
  selected: value,
  onChange,
  isDisabled = false || available.length === 0,
}) {
  const containerClassName = modifier ? `${blockName} ${blockName}--${modifier}` : blockName
  const selectProps = {
    value,
    onChange,
    disabled: isDisabled,
    children: available.map(optionText => SelectOption(optionText, blockName)),
    className: `${blockName}__select ${blockName}--${entityName}`,
  }
  return (
    <div className={containerClassName}>
      <div className={`${blockName}__wrapper`}>
        <select {...selectProps} />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/tv_channel_selection/TvChannelSelection.js